import type {IRcnAddressKey} from "../types/IRcnAddress";
import {formatRcnHouseNumber, formatRcnStreetName} from "./prices_search/format_rcn_display_name";

// The type word RCN puts in front of a street name decides the phrase; a name without one is a street.
const STREET_TYPES: readonly {pattern: RegExp; phrase: string}[] = [
    {pattern: /^(ulica|ul\.)\s+/i, phrase: "przy ulicy"},
    {pattern: /^(aleja|al\.)\s+/i, phrase: "przy alei"},
    {pattern: /^(plac|pl\.)\s+/i, phrase: "przy placu"},
    {pattern: /^(osiedle|os\.)\s+/i, phrase: "na osiedlu"},
    {pattern: /^rondo\s+/i, phrase: "przy rondzie"},
    {pattern: /^skwer\s+/i, phrase: "przy skwerze"},
    {pattern: /^bulwar\s+/i, phrase: "przy bulwarze"}
];
const DEFAULT_STREET_PHRASE = "przy ulicy";

/** "Ceny mieszkań przy ulicy Racławicka 36, Warszawa", "Ceny mieszkań przy alei Jana Pawła II 12, Warszawa". */
export const getPricesAddressHeadline = ({street, number}: IRcnAddressKey, cityName: string): string => {
    const rawStreet = street.trim();
    const type = STREET_TYPES.find(({pattern}) => pattern.test(rawStreet));
    const streetName = formatRcnStreetName(type ? rawStreet.replace(type.pattern, "") : rawStreet);

    return `Ceny mieszkań ${type?.phrase ?? DEFAULT_STREET_PHRASE} ${streetName} ${formatRcnHouseNumber(number)}, ${cityName}`;
};
import type {IRcnAddressKey} from "../types/IRcnAddress";
import {formatRcnHouseNumber, formatRcnStreetName} from "./prices_search/format_rcn_display_name";

// The type word RCN puts in front of a street name decides the phrase; a name without one is a street.
const STREET_TYPES: readonly {pattern: RegExp; phrase: string}[] = [
    {pattern: /^(ulica|ul\.)\s+/i, phrase: "przy ulicy"},
    {pattern: /^(aleja|al\.)\s+/i, phrase: "przy alei"},
    {pattern: /^(plac|pl\.)\s+/i, phrase: "przy placu"},
    {pattern: /^(osiedle|os\.)\s+/i, phrase: "na osiedlu"},
    {pattern: /^rondo\s+/i, phrase: "przy rondzie"},
    {pattern: /^skwer\s+/i, phrase: "przy skwerze"},
    {pattern: /^bulwar\s+/i, phrase: "przy bulwarze"}
];
const DEFAULT_STREET_PHRASE = "przy ulicy";

/** "Ceny mieszkań przy ulicy Racławicka 36, Warszawa", "Ceny mieszkań przy alei Jana Pawła II 12, Warszawa". */
export const getPricesAddressHeadline = ({street, number}: IRcnAddressKey, cityName: string): string => {
    const rawStreet = street.trim();
    const type = STREET_TYPES.find(({pattern}) => pattern.test(rawStreet));
    const streetName = formatRcnStreetName(type ? rawStreet.replace(type.pattern, "") : rawStreet);

    return `Ceny mieszkań ${type?.phrase ?? DEFAULT_STREET_PHRASE} ${streetName} ${formatRcnHouseNumber(number)}, ${cityName}`;
};
